module.exports = __webpack_public_path__ + "img/price@2x.b022c8f0.png";